import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio_sel",
  "use": "icon-radio_sel-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-radio_sel\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 9c0-4.963 4.038-9 9-9s9 4.037 9 9c0 4.962-4.037 9-9 9-4.962 0-9-4.037-9-9Z\" fill=\"#FFAB11\" /><path d=\"m7.389 12.479-2.769-2.8a.417.417 0 0 1 0-.585.406.406 0 0 1 .578 0l2.48 2.508 6.024-6.08a.404.404 0 0 1 .578 0c.16.161.16.423 0 .584L7.968 12.48a.407.407 0 0 1-.579 0Z\" stroke=\"#FFF\" stroke-width=\".5\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol